import "../App.css";

import { useState } from "react";

import Header from "../ui/Header";
import Welcome from "../ui/Welcome";
import Statistics from "../ui/Statistics";
import Wishes from "../ui/Wishes";
import PersonalThanks from "../ui/PersonalThanks";
import Quiz from "../ui/Quiz";

import ModalWindow from "../ui/ModalWindow";

import Locker from "../ui/ScreenLocker";

interface MainPageProps extends ThemeProps, MobileMode, OrientationMode {
  username: string;
  setAuth: SetBoolean;
  isQuizCompleted: boolean;
  setIsQuizCompleted: SetBoolean;
}

export default function MainPage({
  isMobile,
  isVertical,
  isDark,
  setDark,
  username,
  setAuth,
  isQuizCompleted,
  setIsQuizCompleted,
}: MainPageProps) {
  const [content, setContent] = useState<JSX.Element>(null!);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLockerClosed, setLockerClosed] = useState(true);

  const containerHeight = isMobile
    ? isVertical
      ? "h-[90vh]"
      : "h-[100vh]"
    : isVertical
    ? "h-[97vh]"
    : "h-[94vh]";

  return (
    <main
      className={`overflow-y-hidden overflow-x-hidden h-screen 
      ${
        isDark
          ? "bg-gradient-to-b from-gray-800 to-slate-900 text-gray-200"
          : "bg-gradient-to-b from-white to-red-100 text-black"
      }`}
    >
      {isLockerClosed && (
        <div>
          <Header
            isMobile={isMobile}
            isVertical={isVertical}
            isDark={isDark}
            setDark={setDark}
            setLockerClosed={setLockerClosed}
            isQuizCompleted={isQuizCompleted}
            setAuth={setAuth}
          />
          <div className={`snap-container ${containerHeight}`}>
            <div className="snap-item">
              <Welcome
                isMobile={isMobile}
                isVertical={isVertical}
                isDark={isDark}
                username={username}
                setContent={setContent}
                setModalOpen={setModalOpen}
              />
            </div>
            <div className="snap-item">
              <Statistics
                isMobile={isMobile}
                isVertical={isVertical}
                isDark={isDark}
                setContent={setContent}
                setModalOpen={setModalOpen}
              />
            </div>
            <div className="snap-item">
              <Wishes
                isMobile={isMobile}
                isVertical={isVertical}
                isDark={isDark}
                setContent={setContent}
                setModalOpen={setModalOpen}
              />
            </div>
            <div className="snap-item">
              <PersonalThanks
                isMobile={isMobile}
                isVertical={isVertical}
                isDark={isDark}
                setContent={setContent}
                setModalOpen={setModalOpen}
                username={username}
              />
            </div>
            <div className="snap-item">
              <Quiz
                isMobile={isMobile}
                isVertical={isVertical}
                isDark={isDark}
                isQuizCompleted={isQuizCompleted}
                setQuizCompleted={setIsQuizCompleted}
              />
            </div>
          </div>
          <ModalWindow
            isOpen={isModalOpen}
            setOpen={setModalOpen}
            content={content}
          />
        </div>
      )}
      {!isLockerClosed && (
        <Locker
          isDark={isDark}
          isClosed={isLockerClosed}
          setClosed={setLockerClosed}
        />
      )}
    </main>
  );
}
